import React from "react";
import classNames from "classnames";
import styles from "./parts.module.css";

type Props = {
  text: string;
  type?: "default" | "success" | "warning" | "danger";
};

const BoxItemRibbon = ({ text, type = "default" }: Props) => (
  <div className={classNames(styles["ribbon"], styles[`ribbon--${type}`])}>{text}</div>
);

export default BoxItemRibbon;
